export default {
    comments: 'Comments',
    resource: 'Comment',
    comment: 'Comment',
    id: 'ID',
    'user.username': 'Username',
    created_at: 'Added',
    'product.name': 'Product name',
    'product.brand.title': 'Brand',
    like_count: 'Like count',
    is_approved: 'Is approved',
    description: 'Description',
    rate: 'Rate',
    flag_count: 'Flag count',
    updated_at: 'Updated at',

    delete: 'Delete',
    loading: 'Loading...',
};
